/**
 * @module public/js/constants/roles.js
 * @summary Enumerates role strings used throughout the app.
 */
export const SELLER = 'seller';
export const MANAGER = 'manager';
export const ADMIN = 'admin';
export const UNASSIGNED = 'unassigned';
export const SUPER_ADMIN = 'super_admin';

export default { SELLER, MANAGER, ADMIN, UNASSIGNED, SUPER_ADMIN };
